module.exports = __webpack_public_path__ + "static/media/Delete-Black.46a8de93.svg";